<template>
  <div class="animated fadeIn">
    <b-row class>
      <b-col>
        <h2>ลืมรหัสผ่าน</h2>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col sm="6" md="4">
        <label for="email">อีเมล</label>
        <b-input-group>
          <b-form-input placeholder="ระบุอีเมลที่ใช้ลงทะเบียน" v-model="email" id="email"></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row v-if="email" class="mt-3">
      <b-col sm="6" md="4">
        <b-button variant="primary" @click="confirm">ยืนยัน</b-button>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>
import User from '../../services/http/User'
import ModalLoading from '../../components/ModalLoading'

export default {
  components: {
    ModalLoading
  },
  data () {
    return {
      email: null
    }
  },
  mounted () {
    window.analytics.track('request-reset-password-open')
  },
  methods: {
    async confirm () {
      const h = this.$createElement
      Window.Event.$emit('showModalLoading')

      var user = new User()
      var data = {
        email: this.email
      }
      try {
        var ret = await user.requestResetPassword(data)
        if (ret.code === 1) {
          const successMessage = h('span', ['กรุณาตรวจสอบอีเมลที่ใช้ลงทะเบียน เพื่อตั้งรหัสผ่านใหม่', h('br'), 'หมายเหตุ : ถ้าหาอีเมลไม่เจอ กรุณาตรวจสอบใน Junk mail'])
          await this.$bvModal.msgBoxOk([successMessage], this.$getConst('okModalClass'))
          window.analytics.track('request-reset-password-success')
          this.email = null
        } else {
          await this.$bvModal.msgBoxOk('อีเมลไม่ถูกต้อง', this.$getConst('okModalClass'))
        }
      } catch (error) {
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
        console.log(error)
      }

      Window.Event.$emit('closeModalLoading')
    }
  }
}
</script>
